// extracted by mini-css-extract-plugin
export var active = "_2j-7";
export var backButton = "_2j-6";
export var clone = "_2j-c";
export var collapseBar = "_2j-h";
export var collapseMode = "_2j-j";
export var collapsed = "_2j-l";
export var dragHandle = "_2j-a";
export var dropdownIcon = "_2j-e";
export var expanding = "_2j-k";
export var hidden = "_2j-r";
export var iconContainer = "_2j-o";
export var iconSwapper = "_2j-q";
export var navItem = "_2j-4";
export var navItemIcon = "_2j-d";
export var navProfile = "_2j-5";
export var notificationCountBadge = "_2j-g";
export var notificationDot = "_2j-p";
export var optionsContainer = "_2j-f";
export var primaryNav = "_2j-0";
export var primaryTab = "_2j-m";
export var secondaryNav = "_2j-1";
export var selected = "_2j-n";
export var settingsNav = "_2j-2";
export var settingsNavItems = "_2j-3";
export var show = "_2j-b";
export var sideNav = "_2j-i";
export var teamItem = "_2j-8";
export var userProfileItem = "_2j-9";